import { render, staticRenderFns } from "./KpiSmall.vue?vue&type=template&id=847efa8c&scoped=true"
import script from "./KpiSmall.vue?vue&type=script&lang=js"
export * from "./KpiSmall.vue?vue&type=script&lang=js"
import style0 from "./KpiSmall.vue?vue&type=style&index=0&id=847efa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847efa8c",
  null
  
)

export default component.exports